export default __webpack_public_path__ + "static/media/icn-arrow-open.1c55a427.svg";